import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueAnalytics from 'vue-analytics'
import Meta from 'vue-meta'

import App from './App'
import Home from './components/Home'
import Quiz from './components/Quiz'
import Result from './components/Result'
import Review from './components/Review'

Vue.use(VueRouter)
const routes = [
  { path: '/', component: Home },
  { path: '/quiz', component: Quiz },
  { path: '/result', component: Result },
  { path: '/review', component: Review },
]

Vue.use(Vuex)
import StoreData from './store'
const store = new Vuex.Store(StoreData)

const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history'
})

Vue.use(VueAnalytics, {
    id: 'UA-116743678-1',
    router,
})

Vue.use(Meta)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  store,
  render: h => h(App)
}).$mount('#app')//mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js